import React from "react";

export default function useBodyClass(className) {
  React.useEffect(() => {
    const classes = className ? className.split(/\s+/).filter(Boolean) : [];

    document.documentElement.classList.remove("nav-open");

    if (classes.length) {
      document.body.classList.add(...classes);
    }

    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    return () => {
      if (classes.length) {
        document.body.classList.remove(...classes);
      }
    };
  }, [className]);
}
